/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Fragment } from 'react';
import {
  connectHits,
  connectStateResults,
  connectStats
} from 'react-instantsearch-dom';

import type { SearchPanelHitsProps } from '~/legacy/types';
import { getInsightsFields } from '~/legacy/utils';

const CustomHits = connectStats(
  connectHits(
    connectStateResults(
      ({
        searchResults,
        nbHits,
        hits,
        hitComponent: HitComponent,
        notFoundComponent: NotFoundComponent,
        hitProps = {}
      }: SearchPanelHitsProps) => {
        const { showNbResults = false, showTitle, title } = hitProps;

        return !searchResults ? (
          <></>
        ) : nbHits === undefined || nbHits === 0 ? (
          NotFoundComponent ? (
            <NotFoundComponent />
          ) : (
            <Fragment />
          )
        ) : (
          <>
            {showTitle && title && (
              <p className="search-panel__type">{`${title} (${nbHits})`}</p>
            )}
            {showNbResults && <p>{nbHits} results</p>}
            <>
              {hits.slice(0).map((hit: any, index: number) => (
                <HitComponent
                  hit={hit}
                  key={hit.objectID}
                  position={index + 1}
                  insightsFields={getInsightsFields(searchResults, hit)}
                  {...hitProps}
                />
              ))}
            </>
          </>
        );
      }
    )
  )
);

export default CustomHits;
